import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "display": "inline-block",
    "width": "100%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tree_select = _resolveComponent("a-tree-select");
  return _openBlock(), _createElementBlock("span", _hoisted_1, [_createVNode(_component_a_tree_select, _mergeProps({
    treeData: $setup.industries,
    style: {
      "width": "100%"
    },
    fieldNames: $setup.fieldNames,
    allowClear: true,
    treeDefaultExpandAll: true,
    value: $setup.formValue,
    "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.formValue = $event),
    "show-search": "",
    "tree-node-filter-prop": "name"
  }, _ctx.$attrs, {
    placeholder: $props.placeholder
  }), null, 16, ["treeData", "fieldNames", "value", "placeholder"])]);
}